import React from 'react';
import FreeOddSection from './FreeOddSection';
import FaqSection from './FaqSection';
import TestimonialSection from './TestimonialSection';
import ContactSection from './ContactSection';
import NewsSection from './NewsSection';
import NoteSection from './NoteSection';

export default function Main() {
  return (
    <main>
      <FreeOddSection title={"daily"} header="Today's Free Predictions" />
      <FaqSection /> 
      <NewsSection />
      <TestimonialSection />
      <NoteSection />
      <ContactSection />
    </main>
  )
}
